import React, { Component } from 'react';
import { connect } from 'react-redux';
import logo from '../../assets/images/logo.png';
import minimizedlogo from '../../assets/images/sygnet.svg';
import { apiServices } from '../../services/apiServices';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
/*import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';*/

class Header extends Component {


    handleLogout(e) {
        e.preventDefault();
        apiServices.logout();
    }

    toggleSideBar = (e) => {
        // console.log(e.target);
        e.preventDefault();
        e.stopPropagation();
        this.props.toggleSideBar(e);
    }


    render() {

        let community = this.props.community;
        if (!this.props.community) {
            let communityBO = JSON.parse(localStorage.getItem('community'));
            community = communityBO.community;
        }

        this.logo = community.logo ? community.logo : logo;
        this.name = community.project ? community.project : 'iMonitor';

        return (
            <header className="app-header navbar">
			 	<button className="navbar-toggler sidebar-toggler d-lg-none mr-auto" 
			 			type="button" data-toggle="sidebar-show"
			 			onClick = {this.toggleSideBar}
	 			>
    				<span className="navbar-toggler-icon"></span>
	      		</button>

	      	 	<Link to="/dashboard" className="navbar-brand">
	      	 		<img className="navbar-brand-full" src={this.logo} height="52" alt="CoreUI Logo" />
					<span className="project-title">{this.name}</span>
					<img className="navbar-brand-minimized" src={minimizedlogo} width="30" height="30" alt="CoreUI Logo" />
	      	 	</Link>

		      	<button className="navbar-toggler sidebar-toggler d-md-down-none ml-2" 
		      			type="button" data-toggle="sidebar-lg-show"
	      				onClick = {this.toggleSideBar}		
      			>
				   <span className="navbar-toggler-icon"></span>
				</button>

				<Button outline color="primary" className="ml-auto mr-3" onClick={this.handleLogout} >Logout</Button>
			</header>
        );
    }
}

const mapStateToProps = state => {
    return { community: state.community };
}

export default connect(
    mapStateToProps
)(Header)